import type { ProductLogoMediumProps } from '../types';

/**
 * 中サイズのUserAccountsロゴアイコン（User Accounts & Auth）
 */
export function ProductLogoMediumUserAccounts({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      {...props}
    >
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <g transform="translate(132 132)">
        <path
          d="M345 420C321.544 414.094 302.18 400.636 286.908 379.627C271.636 358.617 264 335.287 264 309.637L264 246.429L345 211.714L426 246.429V309.637C426 335.287 418.364 358.617 403.092 379.627C387.82 400.636 368.456 414.094 345 420Z"
          fill="#57D7D9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M371.479 279.088C374.655 275.848 379.872 275.848 383.048 279.088L388.042 284.182C391.129 287.331 391.129 292.373 388.042 295.523L337.307 347.275C334.132 350.514 328.915 350.514 325.739 347.275L301.959 323.018C298.871 319.868 298.871 314.827 301.959 311.677L306.953 306.583C310.129 303.344 315.346 303.344 318.521 306.583L331.523 319.846L371.479 279.088Z"
          fill="#1A2142"
        />
        <path
          d="M239.717 309.638C239.717 336.495 246.768 361.432 260.634 384H132C112.118 384 96 367.882 96 348H72C72 301.608 109.608 264 156 264H239.717V309.638Z"
          fill="white"
        />
        <path
          d="M204 96C243.765 96 276 128.235 276 168C276 194.456 261.731 217.578 240.47 230.093L239.717 230.416V230.529C229.191 236.555 216.998 240 204 240C164.235 240 132 207.765 132 168C132 128.235 164.235 96 204 96Z"
          fill="white"
        />
        <path
          d="M204 0C316.666 0 408 91.3339 408 204C408 206.755 407.944 209.496 407.836 212.225L383.987 202.003C382.917 103.512 302.745 24 204 24C104.589 24 24 104.589 24 204C24 303.411 104.589 384 204 384C222.161 384 239.692 381.307 256.22 376.305C259.438 382.331 263.12 388.201 267.266 393.904C268.072 395.013 268.89 396.105 269.718 397.182C249.097 404.195 226.993 408 204 408C91.3339 408 0 316.666 0 204C0 91.3339 91.3339 0 204 0Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
